import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export type LgpdChave = 'termos' | 'privacidade';

export interface LgpdPaginaPublic {
  chave: LgpdChave;
  conteudo: string;
}

export interface LgpdAdminResponse {
  termos: string;
  privacidade: string;
}

export interface LgpdSolicitacaoPayload {
  nome: string;
  cpf: string;
  email: string;
  telefone: string | null;
  direito: string;
  identificador: string | null;
  descricao: string;
  tem_representante: boolean;
  representante_nome: string | null;
  representante_cpf: string | null;
  representante_vinculo: string | null;
  declaracao_titular: boolean;
  ciencia_art16: boolean;
  turnstile_token: string;
}

@Injectable({ providedIn: 'root' })
export class LgpdService {
  private readonly base = environment.apiBaseUrl;

  constructor(private readonly http: HttpClient) {}

  pagina(chave: LgpdChave): Observable<LgpdPaginaPublic> {
    return this.http.get<LgpdPaginaPublic>(`${this.base}/lgpd/${chave}`);
  }

  adminShow(): Observable<LgpdAdminResponse> {
    return this.http.get<LgpdAdminResponse>(`${this.base}/admin/lgpd`);
  }

  adminUpdate(chave: LgpdChave, conteudo: string): Observable<LgpdPaginaPublic> {
    return this.http.put<LgpdPaginaPublic>(`${this.base}/admin/lgpd`, { chave, conteudo });
  }

  enviarSolicitacao(body: LgpdSolicitacaoPayload): Observable<{ message: string; id: number }> {
    return this.http.post<{ message: string; id: number }>(`${this.base}/lgpd/solicitacoes`, body);
  }
}
